<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/topic/top.png" />
      <div class="topTitle">{{ cid == 12 ? "求购专区" : topicCateName }}</div>
    </div>

    <div class="hasData" v-if="list != null && list.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="-The End-"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div v-for="(item, index) in list" :key="index">
          <router-link
            :to="{ path: '/hotTopicDetails', query: { hid: item.TopicId } }"
          >
            <div class="topicItem">
              <div class="ti_left">
                <div class="tilTitle overFlowOne">#{{ item.TopicName }}#</div>
                <div class="overFlowTwo">{{ item.TopicDesc }}</div>
                <div class="times">
                  浏览次数：{{ item.Views }}次
                  <div>帖子数：{{ item.PostCount }}条</div>
                </div>
              </div>
              <img :src="item.BackImage" class="tiImg" />
            </div>
          </router-link>
        </div>
      </van-list>

      <!-- 加号按钮 -->
      <div class="operateBox" @click.stop="createTopic">
        <div class="openBtn">
          <div class="openTitle">创建话题</div>
          <div>
            <div class="wave_scale"></div>
            <div class="wave_scale delay"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="noData" v-else>
      <img src="../../../static/images/topic/noTopic.png" />
      <div class="no_tips">该类目下，居然还未有人创建话题？</div>
      <div>我来拓荒，成为{{ topicCateName }}下第一个发声的！</div>
      <router-link class="createBtn" to="/publishTopic">创建话题</router-link>
    </div>
  </div>
</template>
<script>
import { List } from "vant";
import { postTopicList, postTopicCateInfo } from "@/api/topic";
export default {
  name: "nextTopic",
  components: {
    "van-list": List,
  },
  data() {
    return {
      delay: false,
      topicCateName: "",
      cid: 0,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    //获取话题分类名称
    getCateIdName() {
      var data = {
        CateId: this.$route.query.cid,
      };
      postTopicCateInfo(data).then((res) => {
        this.topicCateName = res.Data;
        this.loading = true;
        if (this.loading) {
          this.getListHandle();
        }
      });
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        CateId: this.$route.query.cid,
        Type: 0, // 0全部 1热门 2推荐
        Keyword: "",
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      postTopicList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //创建话题
    createTopic() {
      this.$router.push({
        path: "/publishTopic",
        query: { tcid: this.$route.query.cid },
      });
    },
  },
  mounted() {
    this.cid = this.$route.query.cid;
    this.getCateIdName();
  },
};
</script>
<style lang="less" scoped>
.container {
  .top-box {
    width: 100%;
    height: 130px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .topTitle {
      position: absolute;
      z-index: 2;
      bottom: 48px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 350px;
      font-size: 25px;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .noData {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #999999;
    font-size: 11px;
    img {
      width: 102px;
      margin-top: 57px;
    }
    .no_tips {
      color: #333333;
      font-size: 18px;
      margin: 22px 0 12px 0;
    }

    .createBtn {
      width: 100px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      border: 1px solid #d62f2f;
      border-radius: 6px;
      font-size: 12px;
      color: #d62f2f;
      margin-top: 22px;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      -ms-border-radius: 6px;
      -o-border-radius: 6px;
    }
  }
  .operateBox {
    position: fixed;
    right: 12px;
    bottom: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    -o-border-radius: 30px;
    .openBtn {
      width: 60px;
      height: 60px;
      overflow: visible;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      .openTitle {
        color: #d62f2f;
        width: 50%;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
      }
      .wave_scale {
        position: absolute;
        width: 100%;
        height: 100%;
        top: -2px;
        left: -2px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        z-index: -1;
        animation: wave_scale 3s linear infinite;
        -webkit-animation: wave_scale 3s linear infinite;
      }
      .delay {
        animation: wave_scale 3s linear infinite 1.5s;
        -webkit-animation: wave_scale 3s linear infinite 1.5s;
      }
      @keyframes wave_scale {
        from {
          opacity: 10;
          transform: scale(1);
          -webkit-transform: scale(1);
          -moz-transform: scale(1);
          -ms-transform: scale(1);
          -o-transform: scale(1);
        }
        to {
          opacity: 0;
          transform: scale(1.5);
          -webkit-transform: scale(1.5);
          -moz-transform: scale(1.5);
          -ms-transform: scale(1.5);
          -o-transform: scale(1.5);
        }
      }

      @-webkit-keyframes wave_scale {
        from {
          opacity: 10;
          transform: scale(1);
          -webkit-transform: scale(1);
          -moz-transform: scale(1);
          -ms-transform: scale(1);
          -o-transform: scale(1);
        }
        to {
          opacity: 0;
          transform: scale(1.5);
          -webkit-transform: scale(1.5);
          -moz-transform: scale(1.5);
          -ms-transform: scale(1.5);
          -o-transform: scale(1.5);
        }
      }
    }
  }
}
</style>
